module.exports = __webpack_public_path__ + "img/service-flow-planner-1_m.bdffcf2d.svg";